let direct = require(`./redirect`).default;

export default [
  {
    path: "*",
    meta: {
      public: true
    },
    redirect: {
      path: "/404"
    }
  },
  {
    path: "/404",
    meta: {
      public: true
    },
    name: "NotFound",
    component: () => import(`@/views/NotFound.vue`)
  },
  {
    path: "/403",
    meta: {
      public: true
    },
    name: "AccessDenied",
    component: () => import(`@/views/Deny.vue`)
  },
  {
    path: "/500",
    meta: {
      public: true
    },
    name: "ServerError",
    component: () => import(`@/views/Error.vue`)
  },
  {
    path: "/login",
    meta: {
      public: true
    },
    name: "Login",
    component: () => import(`@/views/Login.vue`)
  },
  {
    path: "/emergency/:type",
    meta: { public: true },
    name: "Public Emergency",
    component: () => import(`@/views/emergency/Emergency.vue`)
  },
  {
    path: "/print",
    meta: {
      public: true
    },
    name: "EdpassPrint",
    component: () => import(`@/views/EdpassPrint.vue`)
  },
  {
    path: "/print-qr",
    meta: {
      public: true
    },
    name: "EdpassPrintQR",
    component: () => import(`@/views/EdpassPrintQRFormatted.vue`)
  },
  {
    path: "/company/login",
    meta: {
      public: true
    },
    name: "Company Login",
    component: () => import(`@/views/CompanyLogin.vue`)
  },
  {
    path: "/",
    meta: {},
    name: "Root",
    redirect: direct
  },
  // {
  //   path: "/",
  //   meta: {},
  //   name: "Root",
  //   redirect: {
  //     name: !localStorage.token ? "Company Login" : "Signed in"
  //   }
  // },
  {
    path: "/dashboard",
    meta: { breadcrumb: true },
    name: "Dashboard",
    component: () => import(`@/views/Dashboard.vue`)
  },
  {
    path: "/bulkprocess",
    meta: { breadcrumb: true },
    name: "Bulk Process",
    component: () => import(`@/views/BulkProcess.vue`)
  },
  {
    path: "/company/profile",
    meta: { breadcrumb: true },
    name: "Profile",
    component: () => import(`@/views/Profile/Profile.vue`)
  },
  {
    path: "/company/company-profile",
    meta: { breadcrumb: true },
    name: "Company Profile",
    component: () => import(`@/views/CompanyProfile/Profile.vue`)
  },
  {
    path: "/staff",
    meta: { breadcrumb: true },
    name: "Staff",
    component: () => import(`@/views/staff/Staffs.vue`)
  },
  {
    path: "/staff/create/:id",
    meta: { breadcrumb: true },
    name: "Staff Create",
    component: () => import(`@/views/staff/StaffCreate.vue`)
  },
  {
    path: "/visitors",
    meta: { breadcrumb: true },
    name: "Visitors",
    component: () => import(`@/views/visitors/Visitors.vue`)
  },
  {
    path: "/visitors/create/:id",
    meta: { breadcrumb: true },
    name: "Visitor Create",
    component: () => import(`@/views/visitors/VisitorCreate.vue`)
  },
  {
    path: "/students",
    meta: { breadcrumb: true },
    name: "Students",
    component: () => import(`@/views/students/Students.vue`)
  },
  {
    path: "/students/create/:id",
    meta: { breadcrumb: true },
    name: "Student Create",
    component: () => import(`@/views/students/StudentsCreate.vue`)
  },
  {
    path: "/contractors",
    meta: { breadcrumb: true },
    name: "Contractors",
    component: () => import(`@/views/contractor/Contractors.vue`)
  },
  {
    path: "/classTypes/create/:id",
    meta: { breadcrumb: true },
    name: "Class Types Create",
    component: () => import(`@/views/classTypes/ClassTypeCreate.vue`)
  },
  {
    path: "/classTypes",
    meta: { breadcrumb: true },
    name: "Class Types",
    component: () => import(`@/views/classTypes/ClassTypes.vue`)
  },
  {
    path: "/contractor/create/:id",
    meta: { breadcrumb: true },
    name: "Contractor Create",
    component: () => import(`@/views/contractor/ContractorCreate.vue`)
  },
  {
    path: "/media",
    meta: {},
    name: "Media",
    props: route => ({ type: route.query.type }),
    component: () => import(`@/views/Media.vue`)
  },
  {
    path: "/report/staff",
    meta: { breadcrumb: true },
    name: "ReportStaff",
    component: () => import(`@/views/reports/ReportStaff.vue`)
  },
  {
    path: "/report/student",
    meta: { breadcrumb: true },
    name: "ReportStudent",
    component: () => import(`@/views/reports/ReportStudent.vue`)
  },
  {
    path: "/report/contractor",
    meta: { breadcrumb: true },
    name: "ReportContractor",
    component: () => import(`@/views/reports/ReportContractor.vue`)
  },
  {
    path: "/report/visitor",
    meta: { breadcrumb: true },
    name: "ReportVisitor",
    component: () => import(`@/views/reports/ReportVisitor.vue`)
  },
  {
    path: "/quickpins",
    meta: { breadcrumb: true },
    name: "Quickpins List",
    component: () => import(`@/views/Quickpins/Quickpins.vue`)
  },
  {
    path: "/quickpins/create/:id",
    meta: { breadcrumb: true },
    name: "Quickpins Create",
    component: () => import(`@/views/Quickpins/QuickpinsCreate.vue`)
  },
  {
    path: "/wwcc",
    meta: { breadcrumb: true },
    name: "Wwcc List",
    component: () => import(`@/views/wwcc/Wwcc.vue`)
  },
  {
    path: "/wwcc/create/:id",
    meta: { breadcrumb: true },
    name: "Wwcc Create",
    component: () => import(`@/views/wwcc/WwccCreate.vue`)
  },
  {
    path: "/policies",
    meta: { breadcrumb: true },
    name: "Policies",
    component: () => import(`@/views/policies/Policies.vue`)
  },
  {
    path: "/policies/manage",
    meta: { breadcrumb: true },
    name: "Policy Manage",
    component: () => import(`@/views/policies/PoliciesCreate.vue`)
  },
  {
    path: "/policies/create/:id",
    meta: { breadcrumb: true },
    name: "Policies Create",
    component: () => import(`@/views/policies/PoliciesCreate.vue`)
  },
  {
    path: "/historical-staffs",
    meta: { breadcrumb: true },
    name: "Historical Staff",
    component: () => import(`@/views/HistoricalList/Staffs.vue`)
  },
  {
    path: "/historical-staffs/view/:id",
    meta: { breadcrumb: true },
    name: "Historical Staff View",
    component: () => import(`@/views/HistoricalList/StaffView.vue`)
  },
  {
    path: "/historical-students",
    meta: { breadcrumb: true },
    name: "Historical Students",
    component: () => import(`@/views/HistoricalList/Students.vue`)
  },
  {
    path: "/historical-students/view/:id",
    meta: { breadcrumb: true },
    name: "Historical Student View",
    component: () => import(`@/views/HistoricalList/StudentView.vue`)
  },
  {
    path: "/historical-users",
    meta: { breadcrumb: true },
    name: "Historical Users",
    component: () => import(`@/views/HistoricalList/Users.vue`)
  },
  {
    path: "/historical-users/view/:id",
    meta: { breadcrumb: true },
    name: "Historical User View",
    component: () => import(`@/views/HistoricalList/UsersView.vue`)
  },
  {
    path: "/historical-visitors",
    meta: { breadcrumb: true },
    name: "Historical Visitors",
    component: () => import(`@/views/HistoricalList/Visitors.vue`)
  },
  {
    path: "/historical-visitors/view/:id",
    meta: { breadcrumb: true },
    name: "Historical Visitor View",
    component: () => import(`@/views/HistoricalList/VisitorView.vue`)
  },
  {
    path: "/historical-contractors",
    meta: { breadcrumb: true },
    name: "Historical Contractors",
    component: () => import(`@/views/HistoricalList/Contractors.vue`)
  },
  {
    path: "/historical-contractors/view/:id",
    meta: { breadcrumb: true },
    name: "Historical Contractor View",
    component: () => import(`@/views/HistoricalList/ContractorView.vue`)
  },
  {
    path: "/signedIn",
    meta: { breadcrumb: true },
    name: "Signed in",
    component: () => import(`@/views/signedIn/SignedIn.vue`)
  },
  {
    path: "/signedIn/view/:id",
    meta: { breadcrumb: true },
    name: "signedIn View",
    component: () => import(`@/views/signedIn/SignedInView.vue`)
  },
  {
    path: "/signedOut",
    meta: { breadcrumb: true },
    name: "Signed out",
    component: () => import(`@/views/signedOut/SignedOut.vue`)
  },
  {
    path: "/signedOut/view/:id",
    meta: { breadcrumb: true },
    name: "signedOut View",
    component: () => import(`@/views/signedOut/SignedOutView.vue`)
  },
  {
    path: "/emergency",
    meta: { breadcrumb: true },
    name: "Emergency",
    component: () => import(`@/views/emergency/Emergency.vue`)
  },
  {
    path: "/groups",
    meta: { breadcrumb: true },
    name: "GroupLogs",
    component: () => import(`@/views/groups/GroupLogs.vue`)
  },
  {
    path: "/resources",
    name: "Manage Resources",
    component: () => import(`@/views/resources/ManageResource.vue`)
  },
  {
    path: "/signin",
    name: "SignIn",
    component: () => import(`@/views/tracking/SignIn.vue`)
  },
  {
    path: "/signout",
    name: "SignOut",
    component: () => import(`@/views/tracking/SignOut.vue`)
  },
  {
    path: "/errorlog",
    name: "ErrorLog",
    component: () => import(`@/views/errorlog/ErrorLog.vue`)
  },
  {
    path: "/support",
    name: "Support",
    component: () => import(`@/views/support/Support.vue`)
  }
];
